import Swiper, {Grid, Navigation, Pagination, Autoplay, A11y} from 'swiper';

const SWIPER_A11Y = {
    prevSlideMessage: 'Slide precedente',
    nextSlideMessage: 'Slide successiva',
    firstSlideMessage: 'Questa è la prima slide',
    lastSlideMessage: 'Questa è l’ultima slide',
    paginationBulletMessage: 'Vai alla slide {{index}}'
};

function syncSlidesFocusability(swiper) {
    if (!swiper || !swiper.slides || !swiper.el) {
        return;
    }

    swiper.slides.forEach(function (slide) {
        var visible = slide.classList.contains('swiper-slide-visible');

        if (visible) {
            slide.removeAttribute('aria-hidden');
        } else {
            slide.setAttribute('aria-hidden', 'true');
        }

        var focusables = slide.querySelectorAll('a[href], button, [tabindex]');

        Array.prototype.forEach.call(focusables, function (el) {
            if (visible) {
                if (el.dataset.carouselUnfocusable) {
                    el.removeAttribute('tabindex');
                    delete el.dataset.carouselUnfocusable;
                }
            } else if (!el.hasAttribute('tabindex')) {
                el.setAttribute('tabindex', '-1');
                el.dataset.carouselUnfocusable = 'true';
            }
        });
    });
}

function lockContainerScroll(swiper) {
    if (!swiper || !swiper.el || swiper.el.dataset.focusScrollLocked) {
        return;
    }

    var el = swiper.el;
    var restingLeft = el.scrollLeft;
    var restingTop = el.scrollTop;

    el.dataset.focusScrollLocked = 'true';
    el.addEventListener('scroll', function () {
        if (el.scrollLeft !== restingLeft) {
            el.scrollLeft = restingLeft;
        }

        if (el.scrollTop !== restingTop) {
            el.scrollTop = restingTop;
        }
    });
}

var jsCarousel = $(".js-carousel");
var jsSlider = $('.js-slider');
var selectorSeoLinksSlider = '.swiper.js-seolinks-slider';
var selectorPDCatalogGrid = '.swiper.js-content-catalog-grid';
var selectorPDProductGrid = '.swiper.js-product-grid';
var selectorPDProductGridHorizontal = '.swiper.js-product-grid-horizontal';
var selectorPDMosaicGrid = '.swiper.js-mosaic-grid';
var selectorMyAreaHomeSlider = '.swiper.js-myarea-home-slider';

const nuvolaSeoLinksOptions = {
    speed: 400,
    modules: [Pagination, A11y],
    a11y: SWIPER_A11Y,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
    },
    slidesPerView: "auto",
};

const PDCatalogGridOptions = {
    speed: 400,
    spaceBetween: 10,
    modules: [Pagination, A11y],
    a11y: SWIPER_A11Y,
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    on: {
        init: function () {
            const wrapper = this.el.querySelector('.swiper-wrapper');
            // Se il wrapper ha 'flex-wrap' e siamo su mobile (meno di 768px)
            if (wrapper && wrapper.classList.contains('flex-wrap') && window.innerWidth < 768) {
                // Blocca fisicamente l'istanza attiva di Swiper
                this.allowSlideNext = false;
                this.allowSlidePrev = false;
                this.allowTouchMove = false;
            }
        },
        resize: function () {
            const wrapper = this.el.querySelector('.swiper-wrapper');

            if (wrapper && wrapper.classList.contains('flex-wrap')) {
                if (window.innerWidth < 768) {
                    this.allowSlideNext = false;
                    this.allowSlidePrev = false;
                    this.allowTouchMove = false;
                } else {
                    this.allowSlideNext = true;
                    this.allowSlidePrev = true;
                    this.allowTouchMove = true;
                }
            }
        }
    },
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            spaceBetween: 5
        },
        576: {
            slidesPerView: 2
        }
    }
};

const PDProductGridOptions = {
    speed: 400,
    spaceBetween: 10,
    modules: [Pagination, Navigation, A11y],
    a11y: SWIPER_A11Y,
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        lockClass: 'swiper-pagination-hidden'
    },
    watchOverflow: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.swiper-button-next-slider-product-grid',
        prevEl: '.swiper-button-prev-slider-product-grid',
    },
    breakpoints: {
        576: {
            slidesPerView: 'auto'
        },
        992: {
            slidesPerView: 3
        }
    },
    on: {
        init: function (swiper) {
            lockContainerScroll(swiper);
            syncSlidesFocusability(swiper);
        },
        slidesLengthChange: syncSlidesFocusability,
        slideChangeTransitionEnd: syncSlidesFocusability,
        breakpoint: syncSlidesFocusability,
        resize: syncSlidesFocusability
    }
};

const PDProductGridOptionsHorizontal = {
    speed: 400,
    spaceBetween: 10,
    modules: [Pagination, A11y],
    a11y: SWIPER_A11Y,
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true
        },
        992: {
            allowSlideNext: false,
            allowSlidePrev: false,
            allowTouchMove: false
        },
    }
};

const PDMosaicGridOptions = {
    speed: 400,
    spaceBetween: 10,
    modules: [Pagination, A11y],
    a11y: SWIPER_A11Y,
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    }
};

const myAreaHomeSliderOptions = {
    speed: 400,
    modules: [Pagination, A11y],
    a11y: SWIPER_A11Y,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    slidesPerView: 'auto',
};

var resizeCarousel = function(sliderSelector, data, additionalClass) {
    if (sliderSelector.length) {
        if (sliderSelector.data().resolution && BreakpointHelper.isUpTo(sliderSelector.data().resolution)) {
            if (sliderSelector.hasClass('slick-initialized')) {
                sliderSelector.slick('unslick');
            }
            return;
        }
        if (!sliderSelector.hasClass('slick-initialized')) {
            if (data && sliderSelector.hasClass(additionalClass)) {
                sliderSelector.slick(data);
            } else {
                sliderSelector.slick();
            }
            return;
        }
    }
}

var sliderJS = function() {
    if(jsSlider.length) {
        console.log('Slider Active');
        jsSlider.each(function (index) {
            if (!$(this).data().resolution) {
                $(this).slick();
            } else {
                // activate online under a certain resolution
                let carouselResolution = $(this).data().resolution;
                const width = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${carouselResolution}`);
                if (width !== '' && window.matchMedia(`(max-width: ${width})`).matches) {
                    $(this).slick();
                }
            }
        });
    }
};

var PDSliderInit = function() {
    // PD sliderCard
    function refreshSliderCardA11y(swiper) {
        if (!swiper || !swiper.slides) {
            return;
        }
        swiper.slides.forEach(function (slide) {
            var visible = slide.classList.contains('swiper-slide-visible');
            if (visible) {
                slide.removeAttribute('aria-hidden');
            } else {
                slide.setAttribute('aria-hidden', 'true');
            }
            var focusables = slide.querySelectorAll('a[href], button, [tabindex]');
            Array.prototype.forEach.call(focusables, function (el) {
                if (visible) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        });
    }

    const PDSliderCardTravels = $('.slider-card-travels');
    if (PDSliderCardTravels.length > 0) {
        PDSliderCardTravels.each(function(index) {
            // Check if there are big slide img and set slidesPerView param
            let slidesPerViewParam = 4;
            if ($(PDSliderCardTravels[index]).find('.big-slide').length > 0) {
                slidesPerViewParam = "auto";
            }

            new Swiper(PDSliderCardTravels[index], {
                speed: 400,
                spaceBetween: 30,
                modules: [Pagination, Navigation, A11y],
                a11y: SWIPER_A11Y,
                slidesPerView: 1.5,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next.swiper-button-next-slider-card-travels',
                    prevEl: '.swiper-button-prev.swiper-button-prev-slider-card-travels'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                breakpoints: {
                    1200: {
                        slidesPerView: slidesPerViewParam,
                    },
                    992: {
                        slidesPerView: slidesPerViewParam,
                    },
                    768: {
                        slidesPerView: 'auto',
                        navigation: {
                            enabled: false
                        }
                    }
                },
                watchSlidesProgress: true,
                on: {
                    init: function () {
                        // filter and remove slides that do not contain the <picture> tag
                        const swiperWrapper = this.wrapperEl;
                        const slides = Array.from(swiperWrapper.children);

                        slides.forEach(slide => {
                            if (!slide.querySelector('picture')) {
                                swiperWrapper.removeChild(slide);
                            }
                        });

                        this.update();
                        refreshSliderCardA11y(this);
                        this.el.addEventListener('scroll', function () {
                            this.scrollLeft = 0;
                            this.scrollTop = 0;
                        });
                    },
                    transitionEnd: function () {
                        refreshSliderCardA11y(this);
                    },
                    slideChangeTransitionEnd: function () {
                        refreshSliderCardA11y(this);
                    },
                    resize: function () {
                        refreshSliderCardA11y(this);
                    },
                    breakpoint: function () {
                        refreshSliderCardA11y(this);
                    },
                    update: function () {
                        refreshSliderCardA11y(this);
                    }
                },
            });
        });
    }

    // PD Cataloghi grid
    const PDCatalogGrid = $(selectorPDCatalogGrid);
    if (PDCatalogGrid.length > 0 && BreakpointHelper.isDownTo('lg')) {
       new Swiper(selectorPDCatalogGrid, PDCatalogGridOptions);
    }

    // PD Product grid
    const PDProductGrid = $(selectorPDProductGrid);
    if (PDProductGrid.length > 0) {
        new Swiper(selectorPDProductGrid, PDProductGridOptions);
    }

    // PD Product grid horizontal
    const PDProductGridHorizontal = $(selectorPDProductGridHorizontal);
    if (PDProductGridHorizontal.length > 0) {
        new Swiper(selectorPDProductGridHorizontal, PDProductGridOptionsHorizontal);
    }

    //PD ColumnSwiper
    var PDCarouselColumn = $('.js-swiper-pd');

    if (PDCarouselColumn.length > 0) {
        PDCarouselColumn.each(function(index) {
        var $this = $(this);

        var checkSwipe_Mobile = false;
        var checkSwipe_Tablet = false;

        if ($this.hasClass('scrollingDisabled-mobile')) {
            checkSwipe_Mobile = true;
        } 
        
        if ($this.hasClass('scrollingDisabled-tablet')) {
            checkSwipe_Tablet = true;
        }
            
        var touchEnabled_Mobile = !checkSwipe_Mobile;
        var touchEnabled_Tablet = !checkSwipe_Tablet;

        new Swiper(this, {
            slidesPerView:'auto',
            loop: false,
            spaceBetween: 0,
            modules: [Pagination, A11y],
            a11y: SWIPER_A11Y,
            pagination: {
                el: '.swiper-pagination',
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    allowTouchMove: touchEnabled_Mobile
                },
                // when window width is >= 768px
                768: {
                    allowTouchMove: touchEnabled_Tablet
                },
                // when window width is >= 992px
                992: {
                    allowTouchMove: true
                }
            }
        });
    });
}

        //PD Mosaic Grid
        const PDMosaicGrid = $(selectorPDMosaicGrid);
        if (PDMosaicGrid.length > 0 && BreakpointHelper.isDownTo('sm')) {
            new Swiper(selectorPDMosaicGrid, PDMosaicGridOptions);
        }
}

var swiperSlider = function() {
    // Nuvola SEO Slider
    new Swiper('.swiper.js-destination-seo-appr', {
        speed: 400,
        autoplay: false,
        modules: [Pagination, Autoplay, A11y],
        a11y: SWIPER_A11Y,
        pagination: {
           el: '.swiper-pagination',
           type: 'bullets',
           clickable: true
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            // when window width is >= 576px
            576: {
                spaceBetween: 30
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
                spaceBetween: 40
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 3,
            }
        }
    });

    if (BreakpointHelper.isDownTo('lg')) {
        // Nuvola SEO Links Slider
        new Swiper(selectorSeoLinksSlider, nuvolaSeoLinksOptions);
    }

    // Top slider PDP
    new Swiper('.swiper.default', {
        speed: 400,
        spaceBetween: 100,
        modules: [Pagination, Navigation, A11y],
        a11y: SWIPER_A11Y,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });
    
    if (BreakpointHelper.isUpTo('lg')) {
        // Gallery & layout in evidenza desktop
        $('.js-gallery-desktop').addClass('show');

        new Swiper('.swiper.gallery-a', {
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-a',
                prevEl: '.swiper-button-prev.swiper-button-prev-a'
            }
        });

        new Swiper('.swiper.gallery-b', {
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-b',
                prevEl: '.swiper-button-prev.swiper-button-prev-b'
            }
        });

        new Swiper('.swiper.gallery-c', {
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-c',
                prevEl: '.swiper-button-prev.swiper-button-prev-c'
            }
        });

        new Swiper('.swiper.gallery-d', {
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-d',
                prevEl: '.swiper-button-prev.swiper-button-prev-d'
            }
        });

        new Swiper('.swiper.gallery-d-text', {
            speed: 400,
            spaceBetween: 10,
            modules: [Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-d-text',
                prevEl: '.swiper-button-prev.swiper-button-prev-d-text'
            }
        });

        new Swiper('.swiper.gallery-e', {
            speed: 400,
            spaceBetween: 10,
            modules: [Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: "auto",
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-e',
                prevEl: '.swiper-button-prev.swiper-button-prev-e'
            }
        });

        new Swiper('.swiper.gallery-e-text', {
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, Navigation, A11y],
            a11y: SWIPER_A11Y,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-next-e-text',
                prevEl: '.swiper-button-prev.swiper-button-prev-e-text'
            }
        });


    } else {
        // Gallery & layout in evidenza mobile
        $('.js-gallery-mobile').addClass('show');
        new Swiper('.swiper.gallery-mobile-slider', {
            slidesPerView: 'auto',
            speed: 400,
            spaceBetween: 10,
            modules: [Pagination, A11y],
            a11y: SWIPER_A11Y,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        });
    }

    // My Area Home Slider
    if (BreakpointHelper.isDownTo('xl')) {
        new Swiper(selectorMyAreaHomeSlider, myAreaHomeSliderOptions);
    }
}

var swiperResize = function(sliderSelector, options, breakpoint, breakpointDirection) {
    let isInizialized = $(sliderSelector).hasClass("swiper-initialized");
    const defaultOptions = {
        speed: 400,
        autoplay: false,
        modules: [Pagination, Autoplay, A11y],
        a11y: SWIPER_A11Y,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        },
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: "auto",
            }
        }
    };

    if (breakpoint && breakpointDirection && breakpoint !== '' && breakpointDirection !== '') {
        if ((breakpointDirection === 'down' ? BreakpointHelper.isDownTo(breakpoint) : BreakpointHelper.isUpTo(breakpoint))) {
            if (!isInizialized) {
                new Swiper(sliderSelector, options ? options : defaultOptions);
                return;
            }
        } else if (isInizialized) {
            $(sliderSelector).css("transform", "translate3d(0, 0, 0)");
            $(sliderSelector).removeClass("swiper-initialized");
            $(sliderSelector).each(function() {
                $(this)[0].swiper.destroy();
            });
            return;
        }
    } else if (!isInizialized) {
        new Swiper(sliderSelector, options ? options : defaultOptions);
        return;
    }
}

$(document).ready(function() {
    sliderJS();
    PDSliderInit();
});

$(window).on('load', function(){
   swiperSlider();
});

$(window).on('resize', function() {
    resizeCarousel(jsCarousel);
    swiperResize(selectorSeoLinksSlider, nuvolaSeoLinksOptions, 'lg', 'down');
    swiperResize(selectorPDCatalogGrid, PDCatalogGridOptions, 'lg', 'down');
    swiperResize(selectorPDProductGrid, PDProductGridOptions, null, null);
    swiperResize(selectorPDProductGridHorizontal, PDProductGridOptionsHorizontal, 'lg', 'down');
    swiperResize(selectorPDMosaicGrid, PDMosaicGridOptions, 'sm', 'down');
    swiperResize(selectorMyAreaHomeSlider, myAreaHomeSliderOptions, 'xl', 'down');
});
